import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useGetOutletsForCustomersQuery } from "../slices/OutletSlice";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { setFoodList } from "../slices/foodListSlice";
import MemberImage from "../components/ImageManager";

const HomePageScreen = () => {
  const navigate = useNavigate();
  const { id: outlets } = useParams();
  const { userInfo } = useSelector((state) => state.auth);
  // console.log("outletsIds");
  // console.log(outlets);
  const dispatch = useDispatch();
  const apiQuery = `_id=${outlets.split("-")[0]}`;

  const {
    data: outletsDetails,
    isLoading,
    error,
    refetch,
  } = useGetOutletsForCustomersQuery({ query: apiQuery });

  const loadFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    console.log("Visitor ID:", result);
    return result?.visitorId;
  };

  useEffect(() => {
    refetch();
    if (outletsDetails && outletsDetails.length > 0) {
      console.log("outletsDetails sss");
      console.log(outletsDetails);
      const setDatainRedux = async () => {
        dispatch(
          setCredentials({
            ...userInfo,
            visitorId: userInfo?.visitorId
              ? userInfo?.visitorId
              : await loadFingerprint(),
            openedOutletGroup: outletsDetails
              ? outletsDetails[0]?.["outletGroup"]
              : "",
            selectedOutletId: outletsDetails[0],
            outletsDetails: outletsDetails,
            deliveryTo: outlets?.includes("tableOrder")
              ? `${outlets.split("-")[1]} , ${outlets.split("-")[2]}`
              : `${outlets.split("-")[1]} , ${outlets.split("-")[2]}`,
            tableDetails: outlets?.includes("tableOrder")
              ? {
                  tableNumber: outlets.split("-")[2],
                  floor: outlets.split("-")[1],
                }
              : null,
          })
        );
      };
      setDatainRedux();
    }
    dispatch(setFoodList([]));
  }, [outletsDetails, refetch, isLoading]);

  useEffect(() => {
    if (userInfo?.openedOutletGroup !== outlets.split("-")[0])
      dispatch(
        setCredentials({
          ...userInfo,
          selectedItems: {},
        })
      );
  }, [outlets]);

  const handleOrderFoodClick = () => {
    navigate("/foodsList/" + outlets.split("-")[0], {
      state: {
        deliveryTo: `${outlets.split("-")[1]} , ${outlets.split("-")[2]}`,
      },
    });
  };

  return (
    <>
      <Row
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "row",
          width: "90%",
          margin: "auto",
          textAlign: "center",
          marginTop: "3rem",
          color: "black",
        }}
      >
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message>Something went wrong</Message>
        ) : (
          <Col md={8} sm={6} xs="auto" style={{ color: "rgb(17, 93, 102)" }}>
            <div className="home-heading">
              <h5>Welcome to</h5>
              <br />
              {userInfo?.outletsDetails && (
                <h1>{userInfo?.outletsDetails[0]?.outletName}</h1>
              )}

              {/* <h6>{outlet?.companyId?.companyCity}</h6> */}
              <br />
              <br />
              {outlets?.split("-")[1] && (
                <>
                  <h5>
                    Seat - {outlets.split("-")[1]} , {outlets.split("-")[2]}
                  </h5>
                  <br />
                  <br />
                </>
              )}

              <MemberImage
                foodItemId={outletsDetails[0]?._id + "outletImage"}
                imageUpdatedTimeFromDB={outletsDetails[0]?.imageUploadedTime}
                currentlySelling={true}
                photoUploaded={outletsDetails[0]?.imageUploaded}
                width="17rem"
                height="17rem"
              />
              <br />
              <br />
              <br />
              <br />
              <Button
                className="order-btn"
                onClick={handleOrderFoodClick}
                style={{ backgroundColor: "rgb(17, 93, 102)" }}
              >
                Order Food
              </Button>
              <br />
              <br />
              <br />
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            Powered By
            <br />
            <a href="https://www.zpotter.in">zpotter technologies </a>
          </Col>
        )}
      </Row>
    </>
  );
};

export default HomePageScreen;
